import React from 'react';
import { useAppSelector } from 'shared/store';
import { selectActiveOrg } from 'shared/store/auth-slice';
import { selectActiveVisitor } from 'shared/store/shared-selectors';
import { Rrweb } from 'shared/components/Rrweb';
import { useActiveVisitorViewHandling } from 'shared/hooks';
import { getProtocolVersion } from 'sb-lib/env';
import {
  selectIncomingDisplayStream,
  selectTakeoverStatus,
} from 'shared/store/realtime-slice';
import { selectIsTouring } from 'shared/store/tour-slice';
import { selectVisitorChatMessages } from 'shared/store/chat-slice';

const feProtocolVersion = getProtocolVersion();

interface SessionChatMiniRrwebProps {
  isChatCollapsed: boolean;
}

export const SessionChatMiniRrweb: React.FC<SessionChatMiniRrwebProps> = ({
  isChatCollapsed,
}) => {
  const activeVisitor = useAppSelector(selectActiveVisitor);
  const { isDrawActive } = useAppSelector(state => state.dashboard);
  const {
    isConnectedToPeer,
    peerProtocolVersion,
    callStatus,
    isReceivingAudio,
    isReceivingVideo,
    intendedVisitorId,
  } = useAppSelector(state => state.realtime);
  const takeoverStatus = useAppSelector(selectTakeoverStatus);
  const org = useAppSelector(selectActiveOrg);
  const isShowingDisplay = !!useAppSelector(selectIncomingDisplayStream);
  const isTouring = useAppSelector(selectIsTouring);

  const messages = useAppSelector(s => selectVisitorChatMessages(s, activeVisitor?.sbid));

  const isTakeover = takeoverStatus === 'active';
  const isCall = callStatus === 'active';

  // Common functionality for visitor views
  useActiveVisitorViewHandling();

  const isTabBackgrounded =
    !!activeVisitor && !!activeVisitor.sid && !activeVisitor.isPageVisible;

  const isWidgetProtocolDiff =
    !!activeVisitor && !!peerProtocolVersion && peerProtocolVersion !== feProtocolVersion;

  const isShowBanner = isWidgetProtocolDiff;

  if (!intendedVisitorId && !isTouring) {
    return null;
  }

  return (
    <Rrweb
      isCall={isCall}
      isReceivingAudio={isReceivingAudio}
      isReceivingVideo={isReceivingVideo}
      screenTakeoverOn={isTakeover}
      drawOn={isDrawActive}
      isConnectedToPeer={isConnectedToPeer}
      isTabBackgrounded={isTabBackgrounded}
      isShowBanner={isShowBanner}
      isHidden={isShowingDisplay}
      isProxy={org && org.widgetSettings.assetLinking === 'proxy'}
      isChatCollapsed={isChatCollapsed}
      chatMessages={messages.length}
      callStatus={callStatus}
    />
  );
};
